import i18nFactory from '@yandex-int/i18n';

import { ApiMethodExecutingError } from '../../service/Errors';

import * as keyset from './BaseApiMethodExecutor.i18n';

const restI18N = i18nFactory(keyset);
const isProduction = process.env.NODE_ENV === 'production';

const defaultParams: RequestInit = {
    method: 'GET',
    credentials: isProduction ? 'same-origin' : 'include',
    mode: 'cors'
};

const defaultHeaders = {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json'
};

export class BaseApiMethodExecutor {
    protected baseUrl: string;
    protected _defaultHeaders: HeadersInit = defaultHeaders;

    constructor(baseUrl: string) {
        this.baseUrl = this.normalizeBaseUrl(baseUrl);
    }

    protected normalizeBaseUrl(baseUrl: string): string {
        return baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    }

    protected normalizeMethodPath(methodPath: string): string {
        return methodPath.startsWith('/') ? methodPath.substr(1) : methodPath;
    }

    protected getUrl(methodPath: string): string {
        return `${this.baseUrl}${this.normalizeMethodPath(methodPath)}`;
    }

    protected get defaultHeaders(): HeadersInit {
        return this._defaultHeaders;
    }

    protected async createRequest<T>(methodPath: string, params: RequestInit = {}): Promise<T> {
        params.headers = params.headers || this.defaultHeaders;

        const requestUrl = this.getUrl(methodPath);
        const requestParams = { ...defaultParams, ...params };

        const request = new Request(requestUrl, requestParams);
        try {
            const response = await fetch(request);
            const text = await response.text();

            return text ? JSON.parse(text) : ({} as T);
        } catch (error) {
            throw new ApiMethodExecutingError({ message: restI18N('request-error') });
        }
    }
}
